import { cardRef, defineGameCard, onAppear } from '../authoring/index.js';
export const IronSafeCard = defineGameCard({
    id: 'iron_safe',
    gameplay: { type: 'STRUCTURE', cost: 3, baseStats: { attack: 0, health: 6 } },
    presentation: {
        name: 'Железный сейф',
        description: 'Щит 3.',
        glyph: {
            colors: ['#10213A', '#91908E', '#686765', '#424141', '#5D5C5B'],
            rows: [
                '..1111111111111111..',
                '.122222222222222231.',
                '.1311111111111111341',
                '.1312222222222222341',
                '.1314555555555553341',
                '.1314555555555553341',
                '.1314555555555553441',
                '.1314555122255553341',
                '.1314551254515553341',
                '.1314551311515553341',
                '.1314551544515553341',
                '.1314555144445553341',
                '.1314555555555553441',
                '.1314555555555553341',
                '.1314555555555553341',
                '.1314444444444443341',
                '.1311111111111111341',
                '.1454554545444445411',
                '..111111111111111111',
                '..11111111111111111.',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('iron_safe')],
    abilities: [
        onAppear((ctx) => {
            if (ctx.self !== undefined) {
                ctx.ops.addShield(IronSafeCard.id, ctx.self.id, 3, ctx.self.id);
            }
        }),
    ],
    ui: { mechanics: ['shield'] },
});
//# sourceMappingURL=iron_safe.js.map